// extracted by mini-css-extract-plugin
export var actionButtons = "shopping-list-module--action-buttons--7f751";
export var actionCount = "shopping-list-module--action-count--0dfce";
export var actionRow = "shopping-list-module--action-row--08d45";
export var container = "shopping-list-module--container--014f0";
export var deleteButton = "shopping-list-module--delete-button--d954d";
export var deleteButtonText = "shopping-list-module--delete-button-text--04324";
export var dot = "shopping-list-module--dot--3b713";
export var editButton = "shopping-list-module--editButton--74f30";
export var item = "shopping-list-module--item--03316";
export var list = "shopping-list-module--list--d5958";
export var listIcon = "shopping-list-module--list-icon--b86d2";
export var loading = "shopping-list-module--loading--42d0e";
export var name = "shopping-list-module--name--3fde6";
export var nameBox = "shopping-list-module--name-box--563fd";
export var pdfButton = "shopping-list-module--pdfButton--91731";
export var pdfProtectedLink = "shopping-list-module--pdf-protected-link--7651d";